































































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator';
import ProsemirrorViewerInput from '@/editor/editor-block-view/components/ProsemirrorViewerInput.vue';
import ImageWithTransforms from '@/editor/editor-block-view/components/ImageWithTransforms.vue';
import { IImage } from '@/editor/types';
import { EBlockWidth, ERowType } from '@/editor/types/enums';

@Component({
  components: {
    ImageWithTransforms,
    ProsemirrorViewerInput,
  },
  data: () => ({
    ERowType,
  }),
})
export default class EditorNodeImage extends Vue {
  @Prop() node: IImage;
  @Prop() rowType: ERowType;
  @Prop() parentFirstChild: boolean;
  @Prop() parentLastChild: boolean;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() pageWidth: number;
  @Prop() isBlockToggled: boolean;
  @Watch('isBlockToggled') watchIsBlockToggled() {
    if (!this.isBlockToggled) {
      return;
    }

    this.resetTextSize();
  }
  @Watch('pageWidth') updateTextSize() {
    this.resetTextSize();
  }
  @Ref('imageContent') imageContent: HTMLElement;
  @Ref('headingInput') headingInput: Vue;

  isTextLoaded = false;
  minTextSize = 12;
  maxTextSize = 64;
  textFont: { size: number } = { size: 64 };

  get caption(): string {
    return this.node.caption;
  }

  get heading(): string {
    return this.node.heading;
  }

  get isHeadingSet(): boolean {
    return this.node?.heading !== '<p></p>' && !!this.node?.heading;
  }

  get isCaptionSet(): boolean {
    return this.node?.caption !== '<p></p>' && !!this.node?.caption;
  }

  get fontSize(): string {
    return `--fontSize: ${this.textFont?.size}px;`;
  }

  get imageSize(): string {
    return this.node?.imageSize?.toLowerCase();
  }

  get imageAlign(): string {
    return this.node?.imageAlign?.toLowerCase();
  }

  get rowTypeClass(): string {
    return `row-type-${this.rowType?.toLowerCase()}`;
  }

  handleTextLoaded() {
    if (this.isTextLoaded) {
      return;
    }
    this.resetTextSize();
  }

  resetTextSize() {
    this.textFont.size = this.maxTextSize;
    Vue.nextTick(() => {
      this.setTextSize();
    });
  }

  setTextSize() {
    if (!this.isHeadingSet) {
      return;
    }

    const textNode = this.imageContent.querySelector('.image-heading p');

    if (!textNode) {
      return;
    }

    this.isTextLoaded = true;
    const parentContainerWidth = this.headingInput.$el.clientWidth;
    const currentTextWidth = textNode.scrollWidth;
    const currentFontSize = this.maxTextSize;

    const newValue = Math.floor(
      Math.min(
        Math.max(this.minTextSize, (parentContainerWidth / currentTextWidth) * currentFontSize),
        this.maxTextSize
      )
    );

    this.textFont = {
      ...this.textFont,
      size: newValue,
    };
  }
}
